import { useState } from "react";
import { useQuery } from "react-query";
import { getCourierTransactions } from "../../../../MyApi/transactions";
import { formatPrice } from "../../../../utils/formatPrice";
import LoadingSpinner from "../../../UI/spinner";
import AddBalanceModal from "./AddBalanceModal";

const CuiorWallet = ({ stats, total_earnings, id, factor }) => {
  const [isBalanceModalOpen, setIsBalanceModalOpen] = useState(false);
  const toggleBalanceModal = () => setIsBalanceModalOpen((prev) => !prev);

  const { data, isLoading } = useQuery("getCourierTransactions", () =>
    getCourierTransactions("", id),
  );

  const walletStats = [
    { id: 1, name: "إجمالي الأرباح", value: formatPrice(factor, total_earnings) },
    { id: 2, name: "عمليات السحب", value: formatPrice(factor, 0) },
    { id: 3, name: "المدفوعات المعلقه", value: formatPrice(factor, stats.pending_balance) },
    { id: 4, name: "الرصيد الحالي", value: formatPrice(factor, stats.total_balance) },
  ];

  const transactions = data?.data.transactions || [];

  if (isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <div className="mt-5">
      <div className="row ">
        {walletStats.map((wallet, i) => (
          <div className="col-3" key={i}>
            <div className="bg-softGray card border-0 wallet-card">
              <div className="p-3">
                <h6 className=" text-start mb-3 font14 title">{wallet.name}</h6>
                <p className="text-green font16">
                  {wallet.value} {stats.currency}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="table-responsive" dir="rtl">
        <div className="d-flex justify-content-between">
          <h5 className="fw-bold"> المعاملات المالية</h5>
          <div className="d-flex gap-2 w-auto">
            <input type="date" className="form-control" />
            <select name="" id="" className="form-select">
              <option>النوع</option>
            </select>
            <button
              type="button"
              className="btn btn-primary text-nowrap flex-shrink-0"
              onClick={toggleBalanceModal}
            >
              إضافة و سحب رصيد{" "}
            </button>
          </div>
        </div>

        <table className="table align-middle">
          <thead className="bg-light">
            <tr>
              <th>معرف العملية</th>
              <th>النوع</th>
              <th>المبلغ</th>
              <th>التاريخ</th>
              <th className="text-center">الملاحظات</th>
            </tr>
          </thead>

          <tbody>
            {transactions.map((trans) => (
              <tr key={trans.id}>
                <td>{trans.id}</td>

                <td>{trans.type === "increment" ? "إضافة" : "خصم"}</td>

                <td>
                  {formatPrice(trans.currency_factor, trans.amount)}{" "}
                  {trans.currency}
                </td>

                <td>{new Date(trans.created_at).toLocaleString()}</td>

                <td className="text-center">
                  {trans.description || "لا يوجد"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isBalanceModalOpen && (
        <AddBalanceModal
          isOpen={isBalanceModalOpen}
          toggle={toggleBalanceModal}
          targetId={id}
          targetType="courier"
        />
      )}
    </div>
  );
};

export default CuiorWallet;